import { BLOG_POSTS } from "@/data/content";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import BookingButton from "./BookingButton";

export default function Journal() {
  return (
    <section id="journal" className="py-28 lg:py-36" data-testid="journal-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between mb-16 flex-wrap gap-6">
          <div>
            <div className="eyebrow mb-4">06 · Journal</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl leading-tight max-w-xl">
              Notes from the treatment room.
            </h2>
          </div>
          <Link
            to="/blog"
            className="text-sm border-b border-current pb-0.5 inline-flex items-center gap-1.5"
            style={{ color: "var(--sano-olive)" }}
            data-testid="journal-see-all"
          >
            See all journal entries <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {BLOG_POSTS.map((p) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.slug}
              data-testid={`journal-post-${p.slug}`}
              className="group block"
            >
              <div className="overflow-hidden rounded-sm mb-5">
                <img
                  src={p.cover}
                  alt={p.title}
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex gap-3 text-xs uppercase tracking-widest mb-3" style={{ color: "var(--sano-ink-2)" }}>
                <span>{p.date}</span><span>·</span><span>{p.minutes} min read</span>
              </div>
              <h3 className="font-serif-display text-2xl leading-tight mb-3">{p.title}</h3>
              <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--sano-ink-2)" }}>
                {p.excerpt}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm" style={{ color: "var(--sano-olive)" }}>
                Read <ArrowUpRight size={14} strokeWidth={1.5} />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-16 pt-10 border-t flex flex-wrap items-center justify-between gap-4"
             style={{ borderColor: "var(--sano-border)" }}>
          <p className="text-sm max-w-md" style={{ color: "var(--sano-ink-2)" }}>
            Reading is one thing. The body learns by experience. Come into the studio.
          </p>
          <BookingButton testid="journal-book-btn" />
        </div>
      </div>
    </section>
  );
}
